import { chain } from 'ramda'
import {
  getDefaultSellerId,
  usingMultiSeller,
} from '@/checkout-instore-legacy/seller/utils'
import {
  filterOtherDeliveryMethod,
  getOtherDeliveryMethod,
  verifyPurchaseConditionsHasTakeAwayMethod,
} from './utils'

export type UseProductPageOffersSectionProps = {
  skus: Item[]
  selectedSku: Item | undefined
  isAllVariationsSelected: boolean
}

export const useProductPageOffersSection = ({
  skus,
  selectedSku,
  isAllVariationsSelected,
}: UseProductPageOffersSectionProps) => {
  const defaultSellerId = getDefaultSellerId()

  const purchaseConditionsPrices = chain(
    (sku) => sku.purchaseConditionsPrices ?? [],
    skus
  )

  const showThirdPartyLabel =
    usingMultiSeller() &&
    purchaseConditionsPrices.some(
      (purchaseConditionsPrice) =>
        !purchaseConditionsPrice.sellerChain.includes(defaultSellerId)
    )

  const isTakeAwayAvailable =
    purchaseConditionsPrices.filter((purchaseCondition) =>
      verifyPurchaseConditionsHasTakeAwayMethod(purchaseCondition)
    ).length > 0

  const isOtherMethodAvailable =
    filterOtherDeliveryMethod(purchaseConditionsPrices).length > 0

  const hasTakeAwayAndAnotherMethod =
    isTakeAwayAvailable && isOtherMethodAvailable

  const otherDeliveryMethod = getOtherDeliveryMethod(
    purchaseConditionsPrices,
    selectedSku,
    isAllVariationsSelected
  )

  return {
    hasTakeAwayAndAnotherMethod,
    otherDeliveryMethod,
    showThirdPartyLabel,
  }
}
